import { useTheme } from '../hooks/useTheme'

// Single icon button. Shows the icon for the CURRENT theme; tapping flips
// to the opposite. Tooltip describes the action.
export default function ThemeToggle() {
  const { resolved, setPreference } = useTheme()
  const next = resolved === 'dark' ? 'light' : 'dark'
  return (
    <button
      type="button"
      onClick={() => setPreference(next)}
      title={`Switch to ${next} mode`}
      aria-label={`Switch to ${next} mode`}
      style={{
        width: 36,
        height: 36,
        background: 'var(--color-surface-2)',
        borderRadius: 'var(--radius-pill)',
        fontSize: '1.1rem',
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {resolved === 'dark' ? '🌙' : '☀️'}
    </button>
  )
}
